import React from 'react';
import {useNavigate} from 'react-router-dom';
import "./Dashboard.css";

function Dashboard({
                       onLogout,
                       setlist_redirect,
                       userProfile,
                       account_redirect,
                       jam_redirect,
                   }) {
    const navigate = useNavigate();
    const goToActiveSessions = () => {
        navigate('/sessions');
    };
    const goToWhatsOn = () => {
        navigate('/whats-on');
    };
    const goToGroups = () => {
        navigate('/groups');
    };
    const goToGigs = () => {
        navigate('/gigs');
    };
    return (

        <div className={`dashboard ${userProfile["theme"]}`}>
            <div className="profile-container">
                <div className="dashboard-box">
                    <h2>MusicSheetz</h2>
                    <div className="flavor-graphic"></div>
                </div>
                <div className="dashboard-box">
                    <h2>Actions</h2>
                    <div className="profile-box">
                        <button onClick={goToWhatsOn}>Whats On</button>
                        <button onClick={goToGroups}>Groups</button>
                        <button onClick={goToGigs}>Gigs</button>
                        <button onClick={() => window.location.href = jam_redirect}>Jam Night</button>
                        <button onClick={() => window.location.href = setlist_redirect}>Setlists</button>
                        <button onClick={() => window.location.href = account_redirect}>Account</button>
                        <button onClick={onLogout}>Logout</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;